export default {
  namespaced: true,
  state: {
    isPolyclinicSummary: true
  },
  getters: {
    getPolyclinicStatus: state => {
      return state.isPolyclinicSummary;
    }
  },
  mutations: {
    setPolyclinicStatus(state, isPolyclinicSummary) {
      state.isPolyclinicSummary = isPolyclinicSummary;
    }
  },
  actions: {
    setPolyclinicStatus(context, payload) {
      context.commit("setPolyclinicStatus", payload);
    }
  }
};
